import { render, staticRenderFns } from "./table-block.vue?vue&type=template&id=7d869c38&"
import script from "./table-block.vue?vue&type=script&lang=js&"
export * from "./table-block.vue?vue&type=script&lang=js&"
import style0 from "./table-block.vue?vue&type=style&index=0&id=7d869c38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports